import React from 'react';
import BranchSelector from './BranchSelector';

const Footer = () => {
    return (
        <>
            {/* Footer Start */}
            <div className="container-fluid bg-dark text-light footer mt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">

                        <div className="col-lg-3 col-md-6">
                            <a href="/"><img src="img/images/transparent webearslogo.png" alt="WebBears Logo"
                                style={{ height: '12rem' }} /></a>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-4">Services</h4>
                            <a className="btn btn-link" href="/service">Web Developing</a>
                            <a className="btn btn-link" href="/service">E-Commerce</a>
                            <a className="btn btn-link" href="/service">Social Media Presence</a>
                            <a className="btn btn-link" href="/service">IT Consulting</a>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-4">Quick Links</h4>
                            <a className="btn btn-link" href="/about">About Us</a>
                            <a className="btn btn-link" href="/contact">Contact Us</a>
                            <a className="btn btn-link" href="/service">Our Services</a>
                            <a className="btn btn-link" href="/feature">Features</a>
                            <a className="btn btn-link" href="/privacy-policy">Privacy Policy</a>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <BranchSelector variant="footer" />
                            <p className="mt-3 mb-2">
                                <i className="fa fa-envelope me-3 text-primary"></i>
                                <a href="mailto:info@webbears.in" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    info@webbears.in
                                </a>
                            </p>
                            <div className="d-flex pt-4">
                                <a className="btn btn-square btn-outline-light rounded-circle me-2"
                                    href="https://twitter.com/web_bears?t=HuVC18430OfT9jw44urDMw&s=09"><i
                                        className="fab fa-twitter"></i></a>
                                <a className="btn btn-square btn-outline-light rounded-circle me-2"
                                    href="https://www.facebook.com/profile.php?id=61550026255865"><i
                                        className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-square btn-outline-light rounded-circle me-2"
                                    href="https://www.instagram.com/webbears.in/"><i
                                        className="fab fa-instagram"></i></a>
                                <a className="btn btn-square btn-outline-light rounded-circle me-2"
                                    href="https://www.linkedin.com/in/web-bears-639b36289/"><i
                                        className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* Footer End */}


            {/* Copyright Start */}
            <div className="copyright">
                <div className="text-md-start">
                    CopyRight 2023 &copy; <a className="border-bottom" href="/">WebBears</a>
                </div>
            </div>
            {/* Copyright End */}


            {/* Back to Top */}
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top" style={{border: 'none'}}><i
                className="bi bi-arrow-up"></i></button>
        </>
    );
};

export default Footer;
